module.exports = __webpack_public_path__ + "static/media/image_11.e532b2c5.png";